var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.34003 6.78176C6.2067 6.78176 6.0817 6.76076 5.96503 6.71876C5.84836 6.67743 5.74003 6.60676 5.64003 6.50676L1.01503 1.88176C0.831695 1.69843 0.744362 1.4691 0.753028 1.19376C0.761028 0.919097 0.856695 0.690097 1.04003 0.506764C1.22336 0.32343 1.45669 0.231763 1.74003 0.231763C2.02336 0.231763 2.2567 0.32343 2.44003 0.506764L6.34003 4.40676L10.265 0.481763C10.4484 0.29843 10.6777 0.210763 10.953 0.218763C11.2277 0.22743 11.4567 0.32343 11.64 0.506764C11.8234 0.690097 11.915 0.92343 11.915 1.20676C11.915 1.4901 11.8234 1.72343 11.64 1.90676L7.04003 6.50676C6.94003 6.60676 6.8317 6.67743 6.71503 6.71876C6.59836 6.76076 6.47336 6.78176 6.34003 6.78176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseDown);
export default __webpack_public_path__ + "static/media/collapse_down.fb31588e64bba5e12b69760706188e21.svg";
export { ForwardRef as ReactComponent };